import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Mail } from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const FinalCTASection = () => {
  return (
    <section id="contact" className="py-20 md:py-28 bg-golden" data-testid="final-cta-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          className="text-2xl sm:text-3xl lg:text-4xl font-heading font-bold text-carbon mb-6 tracking-tight leading-tight"
          {...fadeInUp}
        >
          You can see the problem. You are less sure what is causing it.
        </motion.h2>

        <motion.p
          className="text-base text-carbon/80 mb-10 leading-relaxed max-w-xl mx-auto"
          {...fadeInUp}
        >
          Absence, staff turnover, complaints, low trust or difficult conversations can place real pressure on leaders. Ollie helps you bring the evidence together, understand what may be driving the issue and decide what to do next.
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" {...fadeInUp}>
          <Link
            to="/contact"
            className="bg-carbon text-white px-7 py-3.5 font-semibold text-sm hover:bg-carbon/90 transition-colors inline-flex items-center justify-center"
            data-testid="final-cta-talk-btn"
          >
            Talk to Ollie
            <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </motion.div>

        <motion.div className="flex items-center justify-center gap-2 text-carbon/70" {...fadeInUp}>
          <Mail className="w-4 h-4" />
          <a href="mailto:ollie@kalobrate.com" className="text-sm hover:text-carbon transition-colors">
            ollie@kalobrate.com
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
